import React, { useState, useEffect } from 'react';

const AdminForm = ({ admin, onSubmit, onReset }) => {
	const [username, setUsername] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [adminId, setAdminId] = useState('');
	const [formTitle, setFormTitle] = useState('Create Admin');

	useEffect(() => {
		if (admin) {
			setUsername(admin.username || '');
			setEmail(admin.email || '');
			setPassword(''); // Don't populate password field for security
			setAdminId(admin.admin_id || '');
			setFormTitle('Edit Admin');
		} else {
			setUsername('');
			setEmail('');
			setPassword('');
			setAdminId('');
			setFormTitle('Create Admin');
		}
	}, [admin]);

	const handleSubmit = (e) => {
		e.preventDefault();

		const formData = {
			username,
			email,
			password: password || undefined, // Only include password if provided
		};

		onSubmit(formData);
	};

	const handleReset = () => {
		setUsername('');
		setEmail('');
		setPassword('');
		setAdminId('');
		setFormTitle('Create Admin');

		if (onReset) {
			onReset();
		}
	};

	return (
		<form id="adminForm" onSubmit={handleSubmit}>
			<h5 className="mb-3" id="adminFormTitle">
				{formTitle}
			</h5>
			<input type="hidden" name="admin_id" value={adminId} />

			<div className="form-group">
				<label htmlFor="username">Username:</label>
				<input
					type="text"
					className="form-control"
					id="username"
					name="username"
					value={username}
					onChange={(e) => setUsername(e.target.value)}
					required
				/>
			</div>

			<div className="form-group">
				<label htmlFor="email">Email:</label>
				<input
					type="email"
					className="form-control"
					id="email"
					name="email"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					required
				/>
			</div>

			<div className="form-group">
				<label htmlFor="password">Password:</label>
				<input
					type="password"
					className="form-control"
					id="password"
					name="password"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					required={!admin} // Only required for new admins
				/>
			</div>

			<div className="form-group">
				<button type="submit" className="btn btn-primary">
					Submit
				</button>
				<button
					type="button"
					className="btn btn-outline-primary"
					onClick={handleReset}
				>
					Reset
				</button>
			</div>
		</form>
	);
};

export default AdminForm;
